// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__M63Ko","text":"style_text__8chw2"};